import Box from '@zenbusiness/zui/Box';
import CircularProgress from '@zenbusiness/zui/CircularProgress';
import ErrorState from '@zenbusiness/zui/ErrorState';
import PageContainer from '@zenbusiness/zui/PageContainer';
import PageHeader from '@zenbusiness/zui/PageHeader';
import Text from '@zenbusiness/zui/Text';

import { useBillingHistory } from '#client/hooks/useBillingHistory';

import { StyledCard } from './BillingHistory.style';
import ChargesTable from './components/ChargesTable';

function BillingHistory() {
  const { data, loading, error } = useBillingHistory();

  if (error) {
    return (
      <PageContainer>
        <PageHeader title="Billing History" />
        <ErrorState
          title="Unable to load billing history"
          message="We're having trouble loading your billing history. Please try again later."
        />
      </PageContainer>
    );
  }

  if (loading) {
    return (
      <PageContainer>
        <PageHeader title="Billing History" />
        <StyledCard>
          <Box display="flex" justifyContent="center" alignItems="center" padding={6}>
            <CircularProgress />
          </Box>
        </StyledCard>
      </PageContainer>
    );
  }

  if (!data || data.length === 0) {
    return (
      <PageContainer>
        <PageHeader title="Billing History" />
        <StyledCard>
          <Text variant="body1">No billing history</Text>
        </StyledCard>
      </PageContainer>
    );
  }

  return (
    <PageContainer>
      <PageHeader title="Billing History" />
      <StyledCard>
        <ChargesTable data={data} />
      </StyledCard>
    </PageContainer>
  );
}

export default BillingHistory;
